import { z } from 'zod';

import {
  emailSchema,
  geoSchema,
  idSchema,
  isoDateSchema,
  phoneSchema,
  tagsSchema,
} from './common.schema';

export const contactSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string().max(200).nullable().optional(),
  email: emailSchema.nullable().optional(),
  phone: phoneSchema.nullable().optional(),
  external_id: z.string().max(255).nullable().optional(),
  channel_ids: z.record(z.string()).default({}),
  tags: tagsSchema.default([]),
  attributes: z.record(z.unknown()).default({}),
  geo: geoSchema.nullable().optional(),
  locale: z.string().min(2).max(8).nullable().optional(),
  timezone: z.string().nullable().optional(),
  pending_erasure: z.boolean(),
  is_anonymized: z.boolean(),
  last_seen_at: isoDateSchema.nullable().optional(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Contact = z.infer<typeof contactSchema>;

export const createContactSchema = z.object({
  name: z.string().max(200).optional(),
  email: emailSchema.optional(),
  phone: phoneSchema.optional(),
  external_id: z.string().max(255).optional(),
  channel_ids: z.record(z.string()).optional(),
  tags: tagsSchema.optional(),
  attributes: z.record(z.unknown()).optional(),
  locale: z.string().min(2).max(8).optional(),
});

// Апдейт: помимо partial, очищаемые поля принимают null (= сбросить значение).
// Без этого попытка сохранить контакт без email/phone падала бы валидацией.
export const updateContactSchema = createContactSchema.partial().extend({
  name: z.string().max(200).nullable().optional(),
  email: emailSchema.nullable().optional(),
  phone: phoneSchema.nullable().optional(),
  external_id: z.string().max(255).nullable().optional(),
  locale: z.string().min(2).max(8).nullable().optional(),
});

export const mergeContactsSchema = z.object({
  primary_id: idSchema,
  duplicate_ids: z.array(idSchema).min(1).max(10),
});

export const contactSearchQuerySchema = z.object({
  q: z.string().min(1).max(255).optional(),
  email: emailSchema.optional(),
  phone: phoneSchema.optional(),
  external_id: z.string().max(255).optional(),
  tag: z.string().max(64).optional(),
});
